import { useState } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Container,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CreateIcon from "@mui/icons-material/Create";
import ContactsIcon from "@mui/icons-material/Contacts";
import LoginIcon from "@mui/icons-material/Login";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import Contactus from "@mui/icons-material/ContactSupport";

export default function DefaultNavbar() {
  const [openNavbar, setOpenNavbar] = useState(false);

  return (
    <AppBar position="static" sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
      <Container maxWidth="xl">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <img
            style={{ width: "20%", height: "20%", maxWidth: "200px" }}
            alt="LabAsService"
            src={require("src/assets/img/labasservice_white.png").default}
          />
          <IconButton
            onClick={() => setOpenNavbar(!openNavbar)}
            sx={{ color: 'white', display: { xs: 'block', lg: 'none' } }}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={{
              display: { xs: openNavbar ? 'flex' : 'none', lg: 'flex' },
              flexDirection: { xs: 'column', lg: 'row' },
              alignItems: 'center',
              gap: 2,
              color: 'white',
              width: { xs: '100%', lg: 'auto' },
              pb: { xs: 2, lg: 0 },
              position: { xs: 'absolute', lg: 'static' },
              top: { xs: '100%', lg: 'auto' },
              left: 0,
              right: 0,
              backgroundColor: { xs: 'rgba(0,0,0,0.8)', lg: 'transparent' },
              zIndex: 1000,
            }}
          >
              <Button
                component={Link}
                to="/register"
                startIcon={<CreateIcon />}
                sx={{ color: 'white', textTransform: 'none' }}
              >
                Register
              </Button>
              <Button
                component={Link}
                to="/admin"
                startIcon={<LoginIcon />}
                sx={{ color: 'white', textTransform: 'none' }}
              >
                Login
              </Button>
              <Button
                href="https://www.zippyops.com/contact-us"
                target="_blank"
                rel="noreferrer"
                startIcon={<ContactsIcon />}
                sx={{ color: 'white', textTransform: 'none' }}
              >
                Contact Us
              </Button>
              <Button
                href="https://support.zippyops.com/"
                target="_blank"
                rel="noreferrer"
                startIcon={<Contactus />}
                sx={{ color: 'white', textTransform: 'none' }}
              >
                Support
              </Button>
              <Button
                href="https://www.zippyops.com/"
                target="_blank"
                rel="noreferrer"
                startIcon={<LibraryBooksIcon />}
                sx={{ color: 'white', textTransform: 'none' }}
              >
                Docs
              </Button>
            </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
